import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form } from 'react-bootstrap'
import MyEditor from '../../components/MyEditor'
import { useNavigate, useParams } from 'react-router-dom'
import axiosInstance from '../../utils/axiosConfig'
import * as CustomToast from '../../components/CustomToastMessage';


function CmsEdit() {
    const { id } = useParams()
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        title: '',
        content: ''
    })
    const [loading, setLoading] = useState(false)

    const fetchCMSDetails = useCallback(async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cms/${id}`);
            if (response.data.success) {
                const tip = response.data.data;
                setFormData({
                    title: tip.title,
                    content: tip.content,
                });
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        }
    }, [id])

    useEffect(() => {
        if (id) {
            fetchCMSDetails();
        }
    }, [id, fetchCMSDetails])
    const handleSubmit = async () => {

        try {
            setLoading(true);
            const url = id
                ? `${process.env.REACT_APP_BACKEND_URL}/api/admin/cms/edit/${id}`
                : `${process.env.REACT_APP_BACKEND_URL}/api/admin/cms/create`;

            const method = id ? 'put' : 'post';

            const response = await axiosInstance({
                method,
                url,
                data: formData
            });

            if (response.data.success) {
                CustomToast.success(response.data.message);
                navigate('/cms');
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    };
    const handleEditorChange = (content) => {
        setFormData(prev => ({
            ...prev,
            content: content
        }));
    };
    return (
        <Layout title={id ? "Edit CMS" : "Create CMS"}>
            <main>
                <div className="card page-card">
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-12">
                                <Form.Group controlId="email">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter title"
                                        value={formData.title}
                                        onChange={(e) => setFormData(prev => ({
                                            ...prev,
                                            title: e.target.value
                                        }))}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-12">
                                <Form.Group controlId="Password">
                                    <Form.Label>Content</Form.Label>
                                </Form.Group>
                                <MyEditor
                                    htmlData={formData.content}
                                    setCourseAdd={(content) => {
                                        handleEditorChange(content);
                                    }}
                                />
                            </div>
                            <div className="col-12 d-flex justify-content-end gap-3">
                                <button className='btn-outline fs-16 fw-700 px-4' onClick={() => navigate('/cms')}>
                                    Cancel
                                </button>
                                <button
                                    className='btn-primary fs-16 fw-700 px-4'
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    type="button"
                                >
                                    Save
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default CmsEdit